// Shared building blocks for the QRT admin panel.
import React from "react";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { fmtIST } from "../../utils/datetime";

export const num = (v) => Number(v || 0).toLocaleString("en-IN");

export const StatCard = ({ label, value, sub, tone }) => (
  <div className={`qrt-stat ${tone || ""}`}>
    <p className="qrt-stat-label">{label}</p>
    <p className="qrt-stat-value">{value}</p>
    {sub && <p className="qrt-stat-sub">{sub}</p>}
  </div>
);

export const Spinner = () => (
  <div className="qrt-spin">
    <Loader2 className="animate-spin" size={22} />
  </div>
);

export const Pager = ({ page, total, pageSize, onPage }) => {
  const totalPages = Math.max(Math.ceil(total / pageSize), 1);
  if (total <= pageSize) return null;
  return (
    <div className="qrt-pager">
      <span>
        Page {page + 1} / {totalPages} · {num(total)} rows
      </span>
      <button type="button" disabled={page === 0} onClick={() => onPage(page - 1)} aria-label="Previous page">
        <ChevronLeft size={14} />
      </button>
      <button
        type="button"
        disabled={page + 1 >= totalPages}
        onClick={() => onPage(page + 1)}
        aria-label="Next page"
      >
        <ChevronRight size={14} />
      </button>
    </div>
  );
};

const CHIP_TONES = {
  active: "g", completed: "g", paid: "g", APPROVED: "g", approved: "g", captured: "g",
  scheduled: "b", created: "n", draft: "n", PENDING: "a", pending: "a", paused: "a",
  suspended: "r", failed: "r", REJECTED: "r", rejected: "r", aborted: "r", frozen: "b",
  cancelled: "r", expired: "r",
};

export const StatusChip = ({ value }) => (
  <span className={`ping-chip ${CHIP_TONES[value] || "n"}`}>{String(value || "—")}</span>
);

/** Display MySQL UTC datetimes in IST (same as wallet / the rest of the app). */
export const fmtDateTime = (d) => fmtIST(d);

export const fmtMoney = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const UserPicker = ({ users, value, onChange, placeholder = "Select a user…" }) => (
  <select
    className="qrt-user-pick"
    value={value || ""}
    onChange={(e) => onChange(e.target.value)}
  >
    <option value="">{placeholder}</option>
    {(users || []).map((u) => (
      <option key={u.id} value={u.id}>
        {u.name} · {u.email}
      </option>
    ))}
  </select>
);
